<template>
  <div :class="{ root: true , visible: isVisibleTrack }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NativeScroll',
  props: {
    isVisibleTrack: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="stylus" scoped>
  .root {
    overflow: auto;
    position: relative;
    height: 100%;
    &::-webkit-scrollbar {
      width: 0.8rem;
      height: 0.6rem;
      background-color: transparent;
      border-radius: 0.6rem;
      cursor: pointer;
    }

    &::-webkit-scrollbar-track {
      border-radius: 0.4rem;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0.7rem;
      background-color: transparent;
    }

    &:hover {
      &::-webkit-scrollbar {
        background-color: rgba(gray, 0.1);
      }
      &::-webkit-scrollbar-track {
        background-color: rgba(gray, 0.6);
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(#36587a, .8);
        &:hover {
          background-color: rgba(#36587a, .8);
        }
      }
    }
  }
  .visible {
    &::-webkit-scrollbar {
      background-color: rgba(gray, 0.1);
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(gray, 0.6);
    }
    &::-webkit-scrollbar-thumb {
      background-color: #36587a;
      &:hover {
        background-color: #36587a;
      }
    }
  }
</style>
